/**
 * @generated SignedSource<<9eaf037909f5490b4dd7fdf2a9778c27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonWizardStepContainerNode$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AddPlayersPrivateStepNode" | "AddPlayersStepNode" | "LessonBookingDetailsStepNode" | "PreviousBookingsStep_TimeSlot">;
  readonly " $fragmentType": "LessonWizardStepContainerNode";
};
export type LessonWizardStepContainerNode$key = {
  readonly " $data"?: LessonWizardStepContainerNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonWizardStepContainerNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonWizardStepContainerNode",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LessonBookingDetailsStepNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddPlayersStepNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreviousBookingsStep_TimeSlot"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddPlayersPrivateStepNode"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "d12c0ad44b277f8cc73b6762fef56b47";

export default node;
